import * as API from '../'
export default {
    getList: params => {
      return API.GET('/api/test/getList', params)
    },
    add:params =>{
      return API.postJsonRequest('/api/test/insert',params)
    },
    edit: params=>{
      return API.postJsonRequest('/api/test/update', params)
    },
    deleteById: params=>{
      return API.postJsonRequest('/api/test/delete', params)
    },
    getDetail:params=>{
        return API.GET('/api/test/getDetail', params)
    }
  }


// WEBPACK FOOTER //
// ./src/api/exam/api_test.js